import { Bot } from 'lucide-react';
import { ROLES, COLOR_VARIANTS } from '../ai_config/Role';

export const formatRoleKey = (title) => {
  return title.toUpperCase().replace(/[^A-Z0-9]/g, '_');
};

export const getAllRoles = () => {
    try {
        const savedCustomRoles = localStorage.getItem('customSidekicks');
        const customRoles = savedCustomRoles ? JSON.parse(savedCustomRoles) : [];
        
        // Transform custom roles to match ROLES format
        const formattedCustomRoles = customRoles.reduce((acc, role) => {
            const roleKey = formatRoleKey(role.title);
            acc[roleKey] = {
                icon: Bot, // Use Bot icon from lucide-react for custom roles
                title: role.title,
                subtitle: role.description || "Custom Sidekick",
                defaultPrompt: `How can I help you with ${role.title}?`,
                actions: role.actions || ["Get Started", "Custom Request"],
                color: role.color || "custom" // Use custom color if none specified
            };
            return acc;
        }, {});

        // Combine default and custom roles
        return { ...ROLES, ...formattedCustomRoles };
    } catch (error) {
        console.error('Error loading custom roles:', error);
        return ROLES;
    }
};